export const NOTIFICATION_EVENTS = '/admin/app/notification-events';
export const NOTIFICATION_TEMPLATES = '/admin/app/notification-templates';
export const NOTIFICATION_EVENT_SETTINGS = 'admin/notification-events/settings/';

//Dashboard
export const DEFAULT_INFO = 'default-info';
export const DEFAULT_ACADEMIC_INFO = 'default-academic-info';
export const DEFAULT_DASHBOARD_INFO = 'default-dashboard-info';
export const AVAILABLE_COURSE_LIST = 'available-course-list';
export const STUDENT_OVERVIEW = 'student-overview';
export const SCHOOL_OVERVIEW = 'school-overview';
export const INSTRUCTOR_STUDENT_OVERVIEW = 'instructor-student-overview';
export const AUDIENCE_OVERVIEW_CHART = 'audience-overview-chart';
export const BROWSER_OVERVIEW_CHART = 'browser-overview-chart';
export const BUSINESS_OVERVIEW = 'business-overview';
export const CONTACT_OVERVIEW = 'contact-overview';
export const TEAM_OVERVIEW = 'team-overview';
export const DOCTORS_LIST = 'doctors-list';
export const UPCOMING_APPOINTMENTS = 'upcoming-appointments';
export const DEFAULT_HOSPITAL_INFO = 'default-hospital-info';
export const HOSPITAL_ACTIVITIES = 'hospital-activities';
export const PATIENT_STATISTICS = 'patient-statistics';
export const HRM_BASIC_DATA = 'hrm-basic-data';
export const PROJECT_OVERVIEW = 'project-overview';
export const YEARLY_HOLIDAY = 'yearly-holiday';
export const EMPLOYEE_OVERVIEW = 'employee-overview';

//Sample pages
export const REPORTS = 'reports';
export const CALENDARS = 'calendars';
export const STAGES = 'stages';
export const TASKS = 'tasks';

//Profile
export const MY_PROFILE = '/my-profile';
export const All_NOTIFICATION = '/all-notifications';
export const LOGOUT = '/admin/log-out';

//app setting view
export const APP_SETTINGS = '/app-setting';
export const GENERAL_SETTINGS = 'general-settings';

//reCAPTCHA
export const GET_RECAPTCHA_SETTINGS = '/get-re-captcha-setting';
//Sms settings
export const GET_SMS_SETTINGS_INFO = 'get-sms-setting-info';
//Email settings
export const GET_EMAIL_SETTINGS = '/admin/app/settings/delivery-settings';

//Users Management
export const USER = 'users';

//DataTable
export const DATATABLE_DATA = 'crud';
export const DATATABLE_SEARCH_SELECT = '/datatable/name';
export const DATATABLE_SERVER_SEARCH_SELECT = '/datatable/serverside/selectable-name';

//Custom TAble
export const CUSTOM_TABLE = 'admin/app/custom-tables';

//roles and users
export const ROLES = 'admin/auth/roles';
export const USERS = 'admin/auth/users';
export const USERS_LIST = 'user-list';
export const ALL_USERS = 'all-users';
export const GET_USERS = 'get/users';
export const GET_STATUSES = 'admin/app/statuses';
export const INVITE_USER = '/admin/auth/users/invite-user';
export const DETACH_ROLES = 'admin/auth/users/detach-roles/';
export const UPDATE_USER_NAME = '/update-user-name/';

//Notification
export const NOTIFICATIONS = '/admin/user/notifications';
export const AUTHENTICATE_USER = '/admin/authenticate-user';
export const LOGIN_USER = '/login-user';

// Language
export const LANGUAGE = 'languages';
export const BASIC_SETTINGS = '/get-basic-setting-data';

// Social links
export const CHANGE_SOCIAL_LINKS = '/change-social-link';

//Payment Methods
export const PAYMENT_METHOD = '/payment-method';
export const GET_PAYMENT_METHOD_STATUS = '/payment-method-status';
export const GET_STRIPE_STATUS = '/stripe-status';
export const GET_PAYPAL_STATUS = '/paypal-status';

// Location
export const LOCATION = 'locations';


// Employee
export const EMPLOYEE = 'employees';


// Attendance
export const ATTENDANCE = 'attendances';
export const ATTENDANCE_DAILY_SUMMARY = 'api/attendances/daily-summary';
export const ATTENDANCE_DAILY_EMPLOYEE_DETAILS = 'api/attendances/daily-employee-details';
export const ATTENDANCE_REAL_TIME_STATS = 'api/attendances/real-time-stats';
export const ATTENDANCE_DASHBOARD_SUMMARY = 'api/attendances/dashboard-summary';
export const ATTENDANCE_EXPORT_SUMMARY = 'api/attendances/export-summary';
export const ATTENDANCE_RECENT_REPORTS = 'api/attendances/recent-reports';


// Working Shift
export const WORKING_SHIFT = 'working-shifts';


// Leave Type
export const LEAVE_TYPE = 'leave-types';


// Leave
export const LEAVE = 'leaves';


// Department
export const DEPARTMENT = 'departments';


// Bank
export const BANK = 'banks';


// Category
export const CATEGORY = 'categories';


// Payroll Period
export const PAYROLL_PERIOD = 'payroll-periods';


// Payroll
export const PAYROLL = 'payrolls';


// Payroll Setting
export const PAYROLL_SETTING = 'payroll-settings';


// Salary Advance
export const SALARY_ADVANCE = 'salary-advances';


// Job Title
export const JOB_TITLE = 'job-titles';


// Holiday
export const HOLIDAY = 'holidays';


// Payment Listing
export const PAYMENT_LISTING = 'payment-listings';
